import axios from "axios";

import { getTokenData } from "@/services/CookiesService";
import { AUTHORIZATION } from "@/internals/constants/cookies";

const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
});

apiClient.interceptors.request.use(
  async (config) => {
    if (!config.headers[AUTHORIZATION]) return config;

    const tokenData = getTokenData();
    if (tokenData.isTokenExpired)
      return (window.location.href = "/?logout=true");
    else config.headers[AUTHORIZATION] = `Bearer ${tokenData.token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
